<template>
  <section class="s-shop-select__item" id="offer" data-step-content="01">

    <div v-if="offer.offer_media_light" class="s-shop-select__media" v-bind:class="{ '--light-only' : offer.offer_dark === true }">
      <template v-if="offer.offer_media_light[0].type === 'image'">
        <img class="s-shop-select__media-item" v-bind:src="offer.offer_media_light[0].url">
      </template>
      <template v-if="offer.offer_media_light[0].type === 'video'">
        <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="offer.offer_media_light[0].url"></video>
      </template>
    </div>

    <div v-if="offer.offer_dark === true" class="s-shop-select__media --dark-only">
      <template v-if="offer.offer_media_dark[0].type === 'image'">
        <img class="s-shop-select__media-item" v-bind:src="offer.offer_media_dark[0].url">
      </template>
      <template v-if="offer.offer_media_dark[0].type === 'video'">
        <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="offer.offer_media_dark[0].url"></video>
      </template>
    </div>
    <div class="s-shop-options">
      <div class="s-kicker" v-if="offer.offer_kicker">{{ offer.offer_kicker }}</div>
      <div class="s-heading s-heading--3" v-if="offer.offer_title">
        <span class="s-heading__text">{{offer.offer_title}}</span>
      </div>
      <p class="s-copy" v-if="offer.offer_copy">{{offer.offer_copy}}</p>

      <div class="s-shop-option --is-selected" v-for="option in offer.offer_options">
        <header class="s-shop-option__header">
          <div class="s-shop-option__name" v-if="option.offer_option_title">{{ option.offer_option_title }}</div>
          <div class="s-shop-option__price">{{ inclusiveString }}<template v-if="option.offer_option_title === 'Coaching-Tool'">{{ inclusiveCoachingString }}</template></div>
        </header>
        <p v-if="option.offer_option_copy" class="s-copy s-copy--s s-shop-option__description">{{ option.offer_option_copy }}</p>
        <ul v-if="option.offer_option_features" class="s-list s-list--check s-list--s s-list--half-tablet s-shop-option__description">
          <li v-for="item in option.offer_option_features" class="s-list__item">{{ item.offer_option_features_line }}</li>
        </ul>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  computed: {
    offer() {
      return this.$store.state.wpdata[wpGlobalData.language].offer.offer_details[0];
    },
    inclusiveString(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_other[0].slang_inclusive;
    },
    inclusiveCoachingString(){
      if(wpGlobalData.language === 'de'){
        return ' für 3 Monate';
      } else {
        return ' for 3 months';
      }
    },
  },
  methods: {
    toggleOffer() {
      this.$store.commit('toggleOffer');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Offer.vue